var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaximize({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    style: {
      enableBackground: "new 0 0 11 11"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.3,10.1c0,0.4,0.3,0.7,0.7,0.7h3.4c0.4,0,0.7-0.3,0.7-0.6c0-0.4-0.3-0.7-0.6-0.7c0,0,0,0,0,0H2.5L4.9,7 c0.3-0.3,0.3-0.7,0-0.9C4.7,5.8,4.3,5.8,4,6.1L1.6,8.5V6.6C1.6,6.3,1.3,6,0.9,6C0.6,6,0.3,6.3,0.3,6.6L0.3,10.1z M10.7,0.9 c0-0.4-0.3-0.7-0.7-0.7H6.6C6.3,0.3,6,0.6,6,0.9c0,0.4,0.3,0.7,0.6,0.7c0,0,0,0,0,0h1.8L6.1,4c-0.3,0.3-0.3,0.7,0,0.9s0.7,0.3,0.9,0 l0,0l2.4-2.4v1.8C9.4,4.7,9.7,5,10.1,5c0.4,0,0.6-0.3,0.6-0.6V0.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximize);
export default __webpack_public_path__ + "static/media/maximize.2e28c8d5d80f6a716edc6ab6259c71d0.svg";
export { ForwardRef as ReactComponent };